<template>
	<div class="mt-5 mb-3">
		<v-checkbox v-model="formCheckbox.status" v-bind:label="formCheckbox.text"
			:disabled="disabled || formCheckbox.isDisabled" aria-label="checkbox status"></v-checkbox>
		<v-expand-transition>
			<div v-if="formCheckbox.status">
				<v-btn
					:disabled="disabled"
					v-if="!contestFormDefined" @click="defineForm">
					Utwórz formularz
				</v-btn>
				<v-btn :disabled="disabled" v-if="!contestFormDefined" @click="getAvailableForms">
					Wybierz formularz
				</v-btn>
				<v-dialog v-model="contestDialog" max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">Wybierz formularz z konkursu</span>
						</v-card-title>
						<v-card-text>
							<v-autocomplete
								v-show="contests"
								v-model="chosenContest"
								:filter="customFilter"
								item-text="name"
								item-value="id"
								:items="contests"
								aria-label="contest"
								label="Konkurs"
							></v-autocomplete>
							<v-select
								v-if="isVolunteerReport && chosenContest !== undefined"
								v-model="chosenReport"
								aria-label="report"
								item-text="term"
								item-value="id"
								:items="reportForms"
								label="Termin">
							</v-select>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="blue" @click="cancelAndCloseDialog">Anuluj</v-btn>
							<v-btn color="primary" flat @click="saveAndCloseDialog">Zapisz</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-btn
					:disabled="disabled"
					v-if="contestFormDefined" @click="defineForm">
					Edytuj formularz
				</v-btn>
				<v-btn
					:disabled="disabled"
					v-if="contestFormDefined" @click="deleteOfferForm">
					Usuń formularz
				</v-btn>
				<v-btn
					v-if="contestFormDefined" 
					@click="printFormPreview"
					:disabled="printLoading"
					:loading="printLoading">
					{{ printLoading ? 'Proszę czekać...' : 'Drukuj' }}
				</v-btn>
				<span class="ml-3" v-if="contestFormDefined">
					<v-icon large class="mr-2" style="color: lightseagreen">check</v-icon>
				</span>
			</div>
		</v-expand-transition>

		<v-snackbar
			class="light-green--text"
			v-model="scoreSavedSnackBar"
			:top="'top'"
		>
			Różnica punktowa została zapisana
			<v-btn
				color="white"
				flat
				@click="scoreSavedSnackBar = false"
			>
				Zamknij
			</v-btn>
		</v-snackbar>

		<egranty-error-list-popup
			title="Nie można usunąć formularza"
			:error-list="unsuccessfulDeleteDialogMessages"
			:is-open="showUnsuccessfulDeleteDialog"
			@close="closeUnsuccessfulDeleteDialog"
		/>

	</div>
</template>

<script>
	import {Api} from "@/api";
	import {PublicContest} from "@/api/generated/PublicContest";
	import {createLabels} from "@/utils/createLabels";
	import {Files} from "@/utils/Files";
	import EgrantyErrorListPopup from "../../../../genericComponents/EgrantyErrorListPopup";

	export default {
		name: "ContestFormsViewItem",
		components: {EgrantyErrorListPopup},
		props: {
			formDefined: {
				type: Boolean,
			},
			checkbox: {
				type: Object,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
		},

		computed: {
			isVolunteerReport () {
				return this.formCheckbox.formType === "volunteer-report";
			}
		},

		watch: {
			contestDialog: function () {
				this.chosenContest = undefined;
				this.chosenReport = undefined;
			},
			formDefined: function () {
				this.contestFormDefined = this.formDefined;
			},
			checkbox: function () {
				this.formCheckbox = this.checkbox;
			},

			"formCheckbox.status": function (val) {
				if (this.formCheckbox.formType !== 'volunteer-report') {
					PublicContest.putFormInclusionStatus(this, {
						contestId: this.$route.params.id,
						genericFormType: this.formCheckbox.formType,
						status: val,
					}, () => {
						this.formCheckbox.status = val;
					});
				}
			},
			chosenContest: function (val) {
				if (this.isVolunteerReport && val !== undefined) {
					PublicContest.getAllReports(this, val, response => {
						this.reportForms = response;
						this.prepareReportForms();
					});
				}
			}
		},

		methods: {
			getAvailableForms () {
				Api.getWithParam(this, "/public-contest/" + this.formCheckbox.formType.toLowerCase().replace(/_/g, "-") + "-names",
					{contestId: this.$route.params.id}, response => {
						this.contests = response.sort((a, b) => a.name.localeCompare(b.name));
            this.contestDialog = true;
					});
			},

			prepareReportForms () {
				let termName;
				let formattedDate;
				this.reportForms.sort(function (x, y) {
					return x.term - y.term;
				});
				this.reportForms.map(form => {
					termName = "Termin " + form.term;
					formattedDate = this.getFormattedDate(form.reportDate);
					if (formattedDate !== "") {
						form.term = termName + " (" + formattedDate + ")";
					} else {
						form.term = termName;
					}
				});
			},

			getFormattedDate (date) {
				if (date !== null && date !== undefined) {
					let year = date[0];
					let month = date[1] < 10 ? '0' + date[1] : date[1];
					let day = date[2] < 10 ? '0' + date[2] : date[2];
					return year + "-" + month + "-" + day;
				} else return "";
			},

			customFilter(item, queryText) {
				const textOne = item.name.toLowerCase();
				const searchText = queryText.toLowerCase();
				return textOne.indexOf(searchText) > -1;
			},

			saveAndCloseDialog() {
				if (this.isVolunteerReport) {
					PublicContest.postDuplicateReportForm(this, {
						loadToReportId: this.formCheckbox.id,
						loadFromReportId: this.chosenReport
					}, () => {
						this.contestFormDefined = true;
						this.$emit("form-chosen");
					});
				} else {
					PublicContest.postForm(this, {
						loadToContestId: this.$route.params.id, loadFromContestId: this.chosenContest,
						genericFormType: this.formCheckbox.formType,
					}, () => {
						this.contestFormDefined = true;
						this.$emit("form-chosen");
					});
				}
				this.contestDialog = false;
			},

			cancelAndCloseDialog() {
				this.contestDialog = false;
			},

			defineForm() {
				if (this.isVolunteerReport) {
					// this.$route.params.id - id konkursu
					// this.formCheckbox.id - id raportu
					this.$router.push("/app/form-generator/PUBLIC/" + this.$route.params.id + "/volunteer-report/" + this.formCheckbox.id);
				} else {
					this.$router.push("/app/form-generator/PUBLIC/" + this.$route.params.id + "/" + this.formCheckbox.formType);
				}
			},

			deleteOfferForm() {
				if (this.isVolunteerReport) {
					deleteReportForm(this);
				} else {
					deleteForm(this);
				}
			},

			isNotEditableCheckbox (formType) {
				return formType === "OFFER" || formType === "MODULE_OFFER" || formType === "FINAL_EVALUATION"
					|| formType === "MONITORING_REPORT" || formType === "FINAL_REPORT" || "COLLABORATION_EVALUATION";
			},

			closeUnsuccessfulDeleteDialog () {
				this.showUnsuccessfulDeleteDialog = false;
			},

			async printFormPreview() {
				this.printLoading = true;
				const contestId = this.$route.params.id;
				const formType = this.formCheckbox.formType;
				const reportId = this.formCheckbox.id;
				const formTitle = this.getFormTypeLabel(formType);
				
				await Files.methods.downloadFileAsBlob(
					this,
					Files.methods.getFormPrintUrl(contestId, formType, reportId),
					`formularz_${formTitle}.pdf`
				);
				
				this.printLoading = false;
			},

			getFormTypeLabel(formType) {
				const labels = {
					'OFFER': 'oferta',
					'MODULE_OFFER': 'oferta_modul',
					'FORMAL_EVALUATION': 'opinia_formalna',
					'INDIVIDUAL_EVALUATION': 'indywidualna_opinia',
					'AGENCY_EVALUATION': 'opinia_placowki',
					'EXPERT_EVALUATION': 'opinia_eksperta',
					'COMMITTEE_COLLABORATION_EVALUATION': 'ocena_wspolpracy_komisja',
					'FINAL_EVALUATION': 'opinia_koncowa',
					'COLLABORATION_EVALUATION': 'ocena_wspolpracy',
					'MONITORING_REPORT': 'raport_monitoringu',
					'FINAL_REPORT': 'sprawozdanie_koncowe'
				};
				return labels[formType] || 'formularz';
			},
		},

		updated () {
			createLabels.addAriaLabelForInputWithRole("checkbox");
		},

		data() {
			return {
				scoreSavedSnackBar: false,
				contests: null,
				reportForms: [],
				formTypeMap: [],
				formCheckbox: this.checkbox,
				chosenContest: undefined,
				chosenReport: undefined,
				contestFormDefined: this.formDefined,
				contestDialog: false,
				showUnsuccessfulDeleteDialog: false,
				unsuccessfulDeleteDialogMessages: null,
				printLoading: false
			};
		},
	};

	function deleteForm (ctx) {
		PublicContest.deleteForm(ctx, ctx.$route.params.id, ctx.formCheckbox.formType, () => {
			ctx.contestFormDefined = false;
			ctx.formCheckbox.status = ctx.isNotEditableCheckbox(ctx.formCheckbox.formType);
			if (ctx.formCheckbox.formType === "INDIVIDUAL_EVALUATION") {
				ctx.formCheckbox.scoreDifference = 0;
			}
			ctx.$emit("form-deleted");
		});
	}

	function deleteReportForm (ctx) {
		PublicContest.deleteReportForm(ctx, ctx.formCheckbox.id, () => {
			ctx.contestFormDefined = false;
			ctx.$emit("form-deleted");
		});
	}

</script>

<style scoped>
	.theme--dark .theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
		background-color: #1B1B1B;
	}
</style>
